import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "print-window-table min-w-full print-only"
};
const _hoisted_2 = {
  class: "print-table-header"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "print-dash"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "print-dash"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2
};
const _hoisted_10 = {
  key: 1,
  class: "description-subrow"
};
const _hoisted_11 = ["colspan"];
const _hoisted_12 = {
  class: "print-description-content"
};
const _hoisted_13 = {
  key: 0,
  class: "print-description-column"
};
const _hoisted_14 = {
  class: "print-description-text"
};
const _hoisted_15 = {
  key: 1,
  class: "print-notes-column"
};
const _hoisted_16 = {
  class: "print-description-text"
};
const _hoisted_17 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_18 = {
  key: 0,
  class: "w-5 h-5 flex items-center justify-center flex-shrink-0"
};
const _hoisted_19 = {
  key: 0,
  "data-replay-unmask": ""
};
const _hoisted_20 = {
  "data-replay-unmask": ""
};
const _hoisted_21 = {
  key: 0,
  "data-replay-unmask": ""
};
const _hoisted_22 = {
  key: 0,
  class: "text-xs"
};
const _hoisted_23 = {
  key: 2,
  class: "text-grey"
};
import { watch, reactive, computed, ref } from 'vue';
import { useBillingTypeLabel } from '@/composables/useBillingTypeLabel';
import { useCustomFlagFormatter } from '@/composables/useCustomFlagFormatter';
import { useResponsiveScreen } from '@/composables/useResponsiveScreen';
import { formatCurrency } from '@/services/utils';
import { useMarkAsBilled } from '@/composables/useMarkAsBilled';
import TimeEntryCard from '@/components/TimeEntryCard.vue';
import { useEntryStore } from '@/services/entryStore';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlDataTable from '@/components/LlDataTable.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import LlTooltip from '@/components/LlTooltip.vue';
import LlIcon from '@/components/LlIcon.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'EntryTable',
  props: {
    entries: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    newEntries: {
      type: Boolean,
      required: false,
      default: false
    },
    leftPanelOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    rightPanelOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    isPrinting: {
      type: Boolean,
      default: false
    },
    selectedEntryId: {
      type: [String, Number],
      default: null
    },
    showLedesCodes: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    entryProcessState: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['editTimeEntry', 'duplicateEntry', 'triggerPrint', 'closeEditPanel', 'update:selectedIds'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      permissions,
      me,
      features
    } = storeToRefs(useMeStore());
    const {
      billingTypeLabel
    } = useBillingTypeLabel();
    const {
      formatCustomFlag
    } = useCustomFlagFormatter();
    const entryStore = useEntryStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();

    // Use the shared responsive composable
    const {
      isPanelAwareSmallScreen
    } = useResponsiveScreen({
      mobileBreakpoint: 768,
      desktopBreakpoint: 1482,
      heightBreakpoint: 897,
      debounceMs: 100
    });
    const emit = __emit;
    const props = __props;
    const {
      canMarkUnmarkEntry,
      handleMarkAsBilled: markAsBilledHandler
    } = useMarkAsBilled(props.filter);
    const handleMarkAsBilled = async item => {
      emit('closeEditPanel', item.id);
      await markAsBilledHandler(item);
    };
    const isSmallScreen = computed(() => {
      return isPanelAwareSmallScreen(props.leftPanelOpen, props.rightPanelOpen);
    });
    const vm = reactive({
      sortBy: [{
        key: props.filter.orderBy,
        order: props.filter.order
      }],
      entryToDelete: null
    });
    const deleteConfirmRef = ref(null);
    const tableSortBy = computed({
      get() {
        return props.newEntries ? [] : vm.sortBy;
      },
      set(value) {
        if (!props.newEntries) {
          vm.sortBy = value;
        }
      }
    });
    watch(() => vm.sortBy, () => {
      props.filter.orderBy = vm.sortBy[0]?.key;
      props.filter.order = vm.sortBy[0]?.order;
    });
    const handleActionButtonClicked = item => {
      emit('duplicateEntry', {
        duplicateEntryId: item.id
      });
    };
    const handleCardDuplicate = entry => {
      emit('duplicateEntry', {
        duplicateEntryId: entry.id
      });
    };
    const handleCardNotesClick = entry => {
      emit('editTimeEntry', {
        entryId: entry.id,
        internalNotes: true,
        isNewEntry: entry.isNewEntry
      });
    };

    // Flag to suppress @click:row when the click was on a selection checkbox.
    // Vuetify fires @update:model-value (selection) before @click:row during the
    // same native click, so we set a flag in the selection handler and check it
    // in editEntry. The flag is cleared on the next microtask via setTimeout(…,0).
    let _selectionInProgress = false;
    const onSelectionChange = ids => {
      _selectionInProgress = true;
      emit('update:selectedIds', ids);
      setTimeout(() => {
        _selectionInProgress = false;
      }, 0);
    };
    const editEntry = (event, row) => {
      // Prevent any issues with event propagation
      if (event) {
        event.stopPropagation();
      }

      // If a selection change just fired, this click was on a checkbox — skip.
      if (_selectionInProgress) return;

      // Fallback guard: Vue may batch the checkbox model update via nextTick,
      // causing @click:row to fire BEFORE @update:model-value on the first click.
      // Check if the clicked <td> contains a checkbox input (= select column).
      if (props.showSelect && event?.target) {
        const td = event.target.closest('td');
        if (td && td.querySelector('input[type="checkbox"]')) return;
      }

      // Extract item from row for Vuetify click handlers
      const item = row?.item || row;
      if (!item) {
        return;
      }
      emit('editTimeEntry', {
        entryId: item.id,
        isNewEntry: item.isNewEntry
      });
    };
    const openEntryOnNotesTab = item => {
      if (!item) {
        return;
      }
      emit('editTimeEntry', {
        entryId: item.id,
        internalNotes: true,
        isNewEntry: item.isNewEntry
      });
    };
    const computedHeaders = computed(() => {
      let headers = props.headers;
      if (props.newEntries) {
        headers = headers.filter(header => header.key !== 'actions');
      }
      return headers;
    });

    // Headers for print table (excludes description, note, and actions columns)
    const printableHeaders = computed(() => {
      return computedHeaders.value.filter(header => header.key !== 'description' && header.key !== 'note' && header.key !== 'actions');
    });

    // Safe accessor for entry process state — avoids repeated optional chaining in template
    const getEntryState = entryId => props.entryProcessState[entryId] || {
      processing: false,
      error: null
    };

    // Function to apply row styling for selected entries
    const getRowProps = ({
      item
    }) => {
      const hasError = getEntryState(item.id).error;
      return {
        class: [item.id == props.selectedEntryId ? 'selected-entry-row' : '', hasError ? 'bg-gray-100 opacity-60' : ''].filter(Boolean).join(' '),
        'data-cy': `entry-row-${item.id}`
      };
    };
    const canDeleteEntry = item => {
      if (!item || !item.id) return false;
      if (item.billed) return false;
      if (me.value.id !== item.account.id && !permissions.value.time.createOthers) return false;
      return true;
    };
    const handleDeleteEntry = item => {
      if (!canDeleteEntry(item)) {
        handleError('Delete operation not allowed for this entry');
        return;
      }
      vm.entryToDelete = item;
      deleteConfirmRef.value.open().then(result => {
        if (result) {
          confirmDelete();
        } else {
          cancelDelete();
        }
      });
    };
    const confirmDelete = async () => {
      if (!vm.entryToDelete) return;

      // Close edit panel if it's showing the entry being deleted
      emit('closeEditPanel', vm.entryToDelete.id);
      try {
        await entryStore.deleteEntry(vm.entryToDelete.id);
      } catch (error) {
        handleError(error);
      } finally {
        cancelDelete();
      }
    };
    const cancelDelete = () => {
      vm.entryToDelete = null;
    };

    // Processed entries for print table - adds description/notes sub-rows
    const processedEntries = computed(() => {
      const processed = [];
      props.entries.forEach(entry => {
        // Add main entry row
        processed.push(entry);

        // Add description/notes sub-row if needed
        const description = props.filter.shortDescriptions ? entry.shortDescription : entry.description;
        const hasDescription = description && description.trim();
        const hasNote = entry.note && entry.note.trim() && props.filter.showInternalNotes;
        if (hasDescription || hasNote) {
          processed.push({
            isDescriptionRow: true,
            description: hasDescription ? description : '',
            note: hasNote ? entry.note : '',
            id: `${entry.id}-description-notes`
          });
        }
      });
      return processed;
    });
    const handleCardDelete = entry => {
      handleDeleteEntry(entry);
    };
    const getHeaderAlignment = headerKey => {
      const centerAligned = ['hours', 'rate', 'amount', 'billingType', 'customFlag', 'startTime', 'endTime', 'taskCode', 'activityCode'];
      return centerAligned.includes(headerKey) ? 'text-center' : 'text-left';
    };
    const triggerPrint = () => {
      emit('triggerPrint');
    };
    __expose({
      triggerPrint
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(props.isPrinting ? 'entry-table-print-mode' : 'entry-table-normal-mode')
      }, [isSmallScreen.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "space-y-1 overflow-y-auto mt-3 px-2",
        style: _normalizeStyle(__props.newEntries ? 'max-height: 400px;' : 'max-height: 650px;')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.entries, entry => {
        return _openBlock(), _createBlock(TimeEntryCard, {
          key: entry.id,
          entry: entry,
          filter: __props.filter,
          "show-start-stop-times": __props.filter.showStartStopTimes,
          "strip-description": __props.filter.shortDescriptions,
          "show-notes": __props.filter.showInternalNotes,
          "show-task-codes": props.showLedesCodes && __props.filter.showTaskCodes,
          "show-activity-codes": props.showLedesCodes && __props.filter.showActivityCodes,
          "show-fixed-fee-column": _unref(features)?.centralizedFixedFeePage && __props.filter.showFixedFeeColumn,
          "hide-actions": __props.newEntries,
          onClick: $event => editEntry($event, {
            item: entry
          }),
          onDuplicate: handleCardDuplicate,
          onDelete: handleCardDelete,
          onOpenNotes: handleCardNotesClick,
          class: _normalizeClass(['cursor-pointer hover:shadow-lg transition-shadow', {
            'selected-entry-card': entry.id == __props.selectedEntryId
          }])
        }, null, 8, ["entry", "filter", "show-start-stop-times", "strip-description", "show-notes", "show-task-codes", "show-activity-codes", "show-fixed-fee-column", "hide-actions", "onClick", "class"]);
      }), 128))], 4)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(props.isPrinting ? 'print-table-container' : 'normal-table-container')
      }, [props.isPrinting ? (_openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("thead", _hoisted_2, [_createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printableHeaders.value, header => {
        return _openBlock(), _createElementBlock("th", {
          key: header.key,
          class: _normalizeClass(['print-header-cell', getHeaderAlignment(header.key)])
        }, _toDisplayString(header.title), 3);
      }), 128))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedEntries.value, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id || index
        }, [!item.isDescriptionRow ? (_openBlock(), _createElementBlock("tr", {
          key: 0,
          class: _normalizeClass(['entry-row', 'print-data-row', {
            'selected-entry-row': item.id == __props.selectedEntryId
          }])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printableHeaders.value, header => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: header.key
          }, [header.key === 'description' ? (_openBlock(), _createElementBlock("td", {
            key: 0,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [_createElementVNode("span", null, _toDisplayString(__props.filter.shortDescriptions ? item.shortDescription : item.description), 1)], 2)) : header.key === 'rate' ? (_openBlock(), _createElementBlock("td", {
            key: 1,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)]),
            "data-replay-unmask": ""
          }, [item.billingType == 'billable' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(formatCurrency)(item.rate)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))], 2)) : header.key === 'amount' ? (_openBlock(), _createElementBlock("td", {
            key: 2,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)]),
            "data-replay-unmask": ""
          }, [item.billingType == 'billable' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(item.amount)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))], 2)) : header.key === 'billingType' ? (_openBlock(), _createElementBlock("td", {
            key: 3,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [_createElementVNode("span", null, _toDisplayString(_unref(billingTypeLabel)(item)), 1)], 2)) : header.key === 'customFlag' ? (_openBlock(), _createElementBlock("td", {
            key: 4,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [_createElementVNode("span", null, _toDisplayString(_unref(formatCustomFlag)(item.customFlag)), 1)], 2)) : header.key === 'taskCode' ? (_openBlock(), _createElementBlock("td", {
            key: 5,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [_createElementVNode("span", null, _toDisplayString(item.codes?.task?.id || '-'), 1)], 2)) : header.key === 'activityCode' ? (_openBlock(), _createElementBlock("td", {
            key: 6,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [_createElementVNode("span", null, _toDisplayString(item.codes?.activity?.id || '-'), 1)], 2)) : header.key === 'fixedFee' ? (_openBlock(), _createElementBlock("td", {
            key: 7,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, [item.charge ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.charge.label || item.charge.description), 1)) : item.billingType === 'fixedFee' ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Unassigned")) : (_openBlock(), _createElementBlock("span", _hoisted_9, "—"))], 2)) : ['hours', 'startTime', 'endTime'].includes(header.key) ? (_openBlock(), _createElementBlock("td", {
            key: 8,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)]),
            "data-replay-unmask": ""
          }, _toDisplayString(item[header.key]), 3)) : (_openBlock(), _createElementBlock("td", {
            key: 9,
            class: _normalizeClass(['print-cell', getHeaderAlignment(header.key)])
          }, _toDisplayString(item[header.key]), 3))], 64);
        }), 128))], 2)) : item.isDescriptionRow ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [_createElementVNode("td", {
          colspan: printableHeaders.value.length,
          class: "print-description-cell"
        }, [_createElementVNode("div", _hoisted_12, [item.description ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.description), 1)])) : _createCommentVNode("", true), item.note && __props.filter.showInternalNotes ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.note), 1)])) : _createCommentVNode("", true)])], 8, _hoisted_11)])) : _createCommentVNode("", true)], 64);
      }), 128))])])) : _createCommentVNode("", true), _createVNode(LlDataTable, {
        headers: computedHeaders.value,
        items: __props.entries,
        "items-length": __props.entries.length,
        "must-sort": !__props.newEntries,
        "disable-sort": __props.newEntries,
        "sort-by": tableSortBy.value,
        "onUpdate:sortBy": _cache[0] || (_cache[0] = $event => tableSortBy.value = $event),
        "onClick:row": editEntry,
        "header-props": {
          class: 'bg-grey-lighten-5 text-uppercase'
        },
        "row-props": getRowProps,
        class: _normalizeClass(['no-print', 'time-entry-table', __props.newEntries ? 'green-border-table' : '']),
        "fixed-header": !__props.newEntries,
        height: __props.newEntries || __props.entries.length <= 10 ? 'auto' : '68vh',
        "data-cy": "time-entries-table",
        "show-select": __props.showSelect,
        "model-value": __props.selectedIds,
        "onUpdate:modelValue": onSelectionChange,
        "item-value": "id"
      }, {
        "item.date": _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_17, [getEntryState(item.id).processing || getEntryState(item.id).error ? (_openBlock(), _createElementBlock("div", _hoisted_18, [getEntryState(item.id).processing ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          size: "16",
          width: "2",
          color: "primary",
          "data-cy": "entry-processing-spinner"
        })) : (_openBlock(), _createBlock(LlTooltip, {
          key: 1,
          text: getEntryState(item.id).error,
          location: "top"
        }, {
          activator: _withCtx(() => [_createVNode(_component_v_icon, {
            icon: "mdi-alert",
            size: "18",
            color: "warning",
            class: "cursor-help",
            "data-cy": "entry-error-icon"
          })]),
          _: 1
        }, 8, ["text"]))])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(item.date), 1)])]),
        "item.description": _withCtx(({
          item
        }) => [_createElementVNode("span", null, _toDisplayString(__props.filter.shortDescriptions ? item.shortDescription : item.description), 1)]),
        "item.rate": _withCtx(({
          item
        }) => [item.billingType == 'billable' ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(formatCurrency)(item.rate)), 1)) : (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          size: "x-small"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-minus", -1)]))]),
          _: 1
        }))]),
        "item.hours": _withCtx(({
          item
        }) => [_createElementVNode("span", _hoisted_20, _toDisplayString(item.hours), 1)]),
        "item.amount": _withCtx(({
          item
        }) => [item.billingType == 'billable' ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(formatCurrency)(item.amount)), 1)) : (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          size: "x-small"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-minus", -1)]))]),
          _: 1
        }))]),
        "item.billingType": _withCtx(({
          item
        }) => [_createElementVNode("span", null, _toDisplayString(_unref(billingTypeLabel)(item)), 1)]),
        "item.customFlag": _withCtx(({
          item
        }) => [item.customFlag === true || item.customFlag === 'true' ? (_openBlock(), _createBlock(LlIcon, {
          key: 0,
          icon: "mdi-check",
          color: "primary",
          size: "x-small"
        })) : (_openBlock(), _createBlock(LlIcon, {
          key: 1,
          icon: "mdi-close",
          color: "error",
          size: "x-small"
        }))]),
        "item.fixedFee": _withCtx(({
          item
        }) => [item.charge ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.charge.label || item.charge.description), 1)) : item.billingType === 'fixedFee' ? (_openBlock(), _createBlock(_component_v_chip, {
          key: 1,
          color: "orange",
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("Unassigned", -1)]))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))]),
        "item.taskCode": _withCtx(({
          item
        }) => [_createElementVNode("span", null, _toDisplayString(item.codes?.task?.id || '-'), 1)]),
        "item.activityCode": _withCtx(({
          item
        }) => [_createElementVNode("span", null, _toDisplayString(item.codes?.activity?.id || '-'), 1)]),
        "item.actions": _withCtx(({
          item
        }) => [_createVNode(_component_v_menu, null, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlSecondaryButton, _mergeProps(props, {
            icon: "mdi-dots-horizontal",
            variant: "text",
            size: "x-small",
            "aria-label": "Time entry actions",
            "data-cy": "entry-actions-menu"
          }), null, 16)]),
          default: _withCtx(() => [_createVNode(_component_v_list, null, {
            default: _withCtx(() => [_createVNode(_component_v_list_item, {
              "data-cy": "duplicate-entry-menu-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                onClick: _withModifiers($event => handleActionButtonClicked(item), ["prevent"]),
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("Duplicate Time Entry", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024), _unref(canMarkUnmarkEntry)(item) ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0,
              "data-cy": "mark-unmark-billed-menu-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                onClick: _withModifiers($event => handleMarkAsBilled(item), ["prevent"]),
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.billed ? 'Unmark as Billed' : 'Mark as Billed'), 1)]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), canDeleteEntry(item) ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                onClick: _withModifiers($event => handleDeleteEntry(item), ["prevent"]),
                class: "cursor-pointer text-error"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Delete Time Entry", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]),
        "item.note": _withCtx(({
          item
        }) => [item.note ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 0,
          icon: "mdi-message-outline",
          variant: "text",
          size: "x-small",
          "aria-label": "Open time entry notes",
          onClick: _withModifiers($event => openEntryOnNotesTab(item), ["stop"])
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["headers", "items", "items-length", "must-sort", "disable-sort", "sort-by", "class", "fixed-header", "height", "show-select", "model-value"])], 2)), _createVNode(LlConfirmationDialog, {
        ref_key: "deleteConfirmRef",
        ref: deleteConfirmRef,
        title: "Delete Time Entry",
        message: "Are you sure you want to delete this time entry? This action cannot be undone.",
        "toggle-text": "Cancel",
        "confirm-text": "Delete",
        "show-warning-icon": true
      }, null, 512)], 2);
    };
  }
};